var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-cases area"
  }, [_c("header", {
    staticClass: "product-cases__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("CASES")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("客户案例")])]), _c("main", {
    staticClass: "product-cases__main clearfix"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/investment-research/CustomerCase.png"),
      alt: ""
    }
  }), _c("p", {
    staticClass: "content"
  }, [_vm._v(" 同花顺智能投研系统将浦发银行研究员从大量的数据搜集、整理、格式排版等机械性的工作上解放出来，助力其建立宏观体系框架，搭建智能报告系统， 源源不断的为其量化交易及智能交易业务提供支撑，最终帮助浦发银行完成“浦银智研”的战略转型。 ")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };